<template>
  <v-banner tile :color="color" single-line>
    <v-row class="justify-center align-center">
      <template v-for="(item, index) in items">
        <v-col cols="auto" :key="'item-' + index">
          <p :class="['text-body', 'ma-0', 'd-inline-block', 'white--text']">
            {{ item.title }}
          </p>
        </v-col>
        <v-col cols="auto" v-if="index < items.length - 1" :key="'divider-' + index" class="white--text">
          &bull;
        </v-col>
      </template>
    </v-row>
  </v-banner>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";

@Component({})
export default class BookingStartHowToBook extends Vue {
  @Prop({ default: false })
  isMobile!: boolean;

  @Prop({ default: false })
  dark!: boolean;

  get color() {
    return getDefaultPartnerColor();
  }

  /**
   * Items for the banner
   * The banner shows the steps of the booking process as per the new design.
   */
  get items() {
    return [
      {
        title: this.$t("bookingForm.BookingStart.item1.title")
      },
      {
        title: this.$t("bookingForm.BookingStart.item2.title")
      },
      {
        title: this.$t("bookingForm.BookingStart.item3.title")
      }
    ];
  }
}
</script>
<style scoped></style>
